module.exports = __webpack_public_path__ + "static/media/loader.eed88857.gif";